// Bump when inbox (or other cached) API shape changes so clients refetch from network.
export const DATA_VERSION = '1748784000';
